<template>
  <div id="form2">
    <h2>Lückentext</h2>
    <br><br>
    <p style="text-align: left;">
        In einem Raum befindet sich eine Geräuschequelle mit  L1  = 100 dB und eine Signalquelle mit 
L2  = 60 dB. Wie hoch ist das Signal-Rausch-Verhältnis in Dezibel?

    </p>
    <p style="text-align: left;">
        <input v-model="message24" placeholder="Feld1" /> dB
    </p>

    <button id="button3" v-on:click="check2">
        Prüfen
    </button>

  </div>
</template>
<script>

export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,

  data() {
    return {
        message24: '',
    }
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    check2() {
        if ( (this.message24 && this.message24 == "-40" || this.message24 == "-40,0") 
            ){
                alert("richtig");
                this.$store.commit('setTaskCompletionState', {varname: "audioForm11_done", state: true})
                localStorage.setItem("audioForm11_done", true);
            }
        else {
            alert("falsch")
        }
    }
  }
};
</script>

<style scoped>
/* #input1 {
    position: absolute;
    left: 260px;
    top: 305px
} */
/* #input2 {
    position: absolute;
    left: 530px;
    top: 205px
} */
#button3 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form2 {
    height: 1000px;;
}
</style>